import LazyModule from '../components/LazyModule';

const LazyCourseModule = LazyModule(() => import('./CourseModule'));

export default LazyCourseModule;
